import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';

//const auth = JSON.parse(window.localStorage.getItem("auth"));

export function* getSupplierDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.SUPPLIER_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.SUPPLIER_DETAILS_FAILURE });
        return error;
    }
}

export function* getPurchaseSelfBillDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.PURCHASE_SELFBILL_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.PURCHASE_SELFBILL_DETAILS_FAILURE });
        return error;
    }
}

export function* getSupplierPaymentDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.SUPPLIER_PAYMNET_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.SUPPLIER_PAYMNET_DETAILS_FAILURE });
        return error;
    }
}


export function* getSupplieInvoiceDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.SUPPLIER_INVOICE_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.SUPPLIER_INVOICE_DETAILS_FAILURE });
        return error;
    }
}

export function* getSupplieBankDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.SUPPLIER_BANK_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.SUPPLIER_BANK_DETAILS_FAILURE });
        return error;
    }
}

export function* getClearDetails() {
    yield put({
        type: actions.CLEAR_PURCHASE_MANAGEMENT_DETAILS_SUCCESS,
    });
}

export default function* purchaseManagementSaga() {
    yield all([
        takeEvery(actions.SUPPLIER_DETAILS_START, getSupplierDetails),
        takeEvery(actions.PURCHASE_SELFBILL_DETAILS_START, getPurchaseSelfBillDetails),
        takeEvery(actions.SUPPLIER_PAYMNET_DETAILS_START, getSupplierPaymentDetails),
        takeEvery(actions.SUPPLIER_INVOICE_DETAILS_START, getSupplieInvoiceDetails),
        takeEvery(actions.SUPPLIER_BANK_DETAILS_START, getSupplieBankDetails),
        takeEvery(actions.CLEAR_PURCHASE_MANAGEMENT_DETAILS_START, getClearDetails)
    ]);
}